var INVERSE_COLOR = {
  transparent: 'primary',
  primary: 'primary',
  secondary: 'primary',
  'primary-inverse': 'primary-inverse',
  brand: 'primary-inverse',
  info: 'primary-inverse',
  alert: 'primary-inverse',
  success: 'primary-inverse',
  danger: 'primary-inverse',
  warning: 'primary-inverse'
};
export var getInverseColor = function getInverseColor(background) {
  var _INVERSE_COLOR$backgr;
  return background ? (_INVERSE_COLOR$backgr = INVERSE_COLOR[background]) !== null && _INVERSE_COLOR$backgr !== void 0 ? _INVERSE_COLOR$backgr : 'primary' : 'primary';
};